import useSWRImmutable from "swr/immutable";

import { PrefMaster } from "@/apis/clients";
import prefMasterApi from "@/apis/master/prefMasterApi";
import { useLoading } from "@/states/loading/operations";

export default function useGetPrefectures() {
  const withLoading = useLoading();

  const fetcher = async (): Promise<PrefMaster[]> => {
    return new Promise((resolve, reject) => {
      withLoading(async () => {
        const result = await prefMasterApi.get();
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  };

  const { data, error } = useSWRImmutable<PrefMaster[], Error>(
    "/pref-master",
    fetcher,
  );

  return {
    prefectures: data,
    prefecturesError: error,
  };
}
